import { defineMessages } from 'react-intl'

const WORKOUT_DIFFICULTY = {
  VERY_EASY: 1,
  EASY: 2,
  GOOD: 3,
  HARD: 4,
  VERY_HARD: 5
}

const messages = defineMessages({
  veryEasy: {
    id: 'workoutDifficulty.veryEasy',
    defaultMessage: 'Very Easy',
    description: 'The label used to describe a workout’s difficulty as too easy'
  },
  easy: {
    id: 'workoutDifficulty.easy',
    defaultMessage: 'Easy',
    description: 'The label used to describe a workout’s difficulty as too easy'
  },
  good: {
    id: 'workoutDifficulty.good',
    defaultMessage: 'Good',
    description: 'The label used to describe a workout’s difficulty as good.'
  },
  hard: {
    id: 'workoutDifficulty.hard',
    defaultMessage: 'Hard',
    description: 'The label used to describe a workout’s difficulty'
  },
  veryHard: {
    id: 'workoutDifficulty.veryHard',
    defaultMessage: 'Very Hard',
    description: 'The label used to describe a workout’s difficulty'
  }
})

const WORKOUT_DIFFICULTY_MESSAGE = {
  [WORKOUT_DIFFICULTY.VERY_EASY]: messages.veryEasy,
  [WORKOUT_DIFFICULTY.EASY]: messages.easy,
  [WORKOUT_DIFFICULTY.GOOD]: messages.good,
  [WORKOUT_DIFFICULTY.HARD]: messages.hard,
  [WORKOUT_DIFFICULTY.VERY_HARD]: messages.veryHard
}

export { WORKOUT_DIFFICULTY_MESSAGE }

export default WORKOUT_DIFFICULTY
